"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=".scalable .scalable-inner{position:absolute;transform-origin:top left}";require("../../external/style-inject/dist/style-inject.es.js").default(e),exports.default=e;
